var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDatasources(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37 14H11C10.4696 14 9.96086 14.2107 9.58579 14.5858C9.21071 14.9609 9 15.4696 9 16V20C9 20.5304 9.21071 21.0391 9.58579 21.4142C9.96086 21.7893 10.4696 22 11 22H37C37.5304 22 38.0391 21.7893 38.4142 21.4142C38.7893 21.0391 39 20.5304 39 20V16C39 15.4696 38.7893 14.9609 38.4142 14.5858C38.0391 14.2107 37.5304 14 37 14ZM15 20H11V16H15V20Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37 26H11C10.4696 26 9.96086 26.2107 9.58579 26.5858C9.21071 26.9609 9 27.4696 9 28V32C9 32.5304 9.21071 33.0391 9.58579 33.4142C9.96086 33.7893 10.4696 34 11 34H37C37.5304 34 38.0391 33.7893 38.4142 33.4142C38.7893 33.0391 39 32.5304 39 32V28C39 27.4696 38.7893 26.9609 38.4142 26.5858C38.0391 26.2107 37.5304 26 37 26ZM15 32H11V28H15V32Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatasources);
export default __webpack_public_path__ + "static/media/Datasources.f20b4724.svg";
export { ForwardRef as ReactComponent };